import { useDebugValue } from 'react';
import { useConditionFieldPath } from './useConditionFieldPath';

export const useConditionFieldNameFieldPath = () => {
  const conditionFieldPath = useConditionFieldPath();
  const fieldPath = `${conditionFieldPath}.fieldName` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
